// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__15_ej","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1QoE2"};